import { useContext } from "react"
import { AuthContextType,AuthContext } from "../Auth"
import { Button } from "@mui/material";
import styles from "./Account.module.css"
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../url";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';


export default function Account(){

    const { auth,setAuth } = useContext(AuthContext) as AuthContextType;
    const navigate= useNavigate();

const logout = async() =>{
    const response = await fetch(`${baseUrl}/logout`, {
    method: "POST",
    credentials: "include",
    })
    const data = await response.json();
    alert(data.message);
    setAuth({ username: "", isAuthenticated: false ,office: undefined , authority:"user"});
    navigate("/login");
}

    return (
        <div className={styles.account}><div className={styles.icon}><AccountCircleIcon/></div><p className={styles.p}>{auth.username}</p>
        <Button onClick={()=>logout()} size="small">ログアウト</Button>
        </div>
    )
}